export enum ConceptModificationType {
  PRODUCT = 'product',
  CONTRACT = 'contract'
}
